import { axiosInstance } from './axios';
import type { UserPreferences } from '../../types/user';

export const emptyPreferences: UserPreferences = {
  desired_roles: [],
  skills: [],
  preferred_locations: [],
  open_to_remote: false,
  experience_level: null,
  min_salary: null,
  salary_currency: 'USD',
  onboarding_completed: false,
};

export const usersApi = {
  getPreferences: async (): Promise<UserPreferences> => {
    const response = await axiosInstance.get<UserPreferences>('/users/me/preferences');
    return response.data;
  },

  /**
   * Saves onboarding answers. Called on every step so a user who drops out
   * halfway resumes where they left off rather than starting over.
   */
  updatePreferences: async (
    preferences: Partial<UserPreferences>
  ): Promise<UserPreferences> => {
    const response = await axiosInstance.put<UserPreferences>('/users/me/preferences', {
      ...emptyPreferences,
      ...preferences,
    });
    return response.data;
  },
};
